export default __webpack_public_path__ + "static/site-logo-fe3de926d7c056a96db1ece922faae8d.png";